import styled, { css } from 'styled-components';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const isOmp = isOmpPlatform();

export const Wrapper = styled.div`
  width: 100%;
  height: 64px;
  background: ${({ theme }) => theme.COLORS.BASE};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  margin: 32px 0 12px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: ${({ theme }) => theme.FONT_SIZES.SMALL};

  ${() =>
    !isOmp &&
    css`
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    `}

  ${() =>
    isOmp &&
    css`
      border: ${({ theme }) => `1px solid ${theme.COLORS.NEUTRAL_110}`};
      border-radius: 6px;
    `}
`;

export const DataBox = styled.div`
  height: 40px;
  background: ${({ theme }) => theme.COLORS.NEUTRAL_5};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  border-radius: 3px;
  display: flex;
  align-items: center;
`;

export const SpanBlack = styled.span`
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-family: ${({ isBald, theme }) =>
    isBald ? theme.FONT.SEMI_BOLD : theme.FONT.REGULAR};
`;

export const DataBoxBlock = styled.div`
  margin: 0px 12px;
`;
